// helper to capitalize strings
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/inline-style-prefix-all/lib/utils/capitalizeString.js
// module id = 368
// module chunks = 6